import React from 'react';
import { Crown, Shield, User, Eye } from 'lucide-react';

const MAX_VISIBLE_BADGES = 2;

const getRoleIcon = (role) => {
  switch (role) {
    case 'owner': return Crown;
    case 'admin': return Shield;
    case 'member': return User;
    case 'viewer': return Eye;
    default: return User;
  }
};

const getRoleBadgeColor = (role) => {
  switch (role) {
    case 'owner': return 'bg-purple-100 text-purple-700';
    case 'admin': return 'bg-blue-100 text-blue-700';
    case 'member': return 'bg-green-100 text-green-700';
    case 'viewer': return 'bg-gray-100 text-gray-600';
    default: return 'bg-gray-100 text-gray-600';
  }
};

const UserTeamBadges = ({ teams, loading, onClick }) => {
  if (loading) {
    return (
      <div className="flex items-center gap-1">
        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs bg-gray-100 text-gray-400 animate-pulse">
          Loading...
        </span>
      </div>
    );
  }

  if (!teams || teams.length === 0) {
    return (
      <button
        onClick={onClick}
        className="inline-flex items-center px-2 py-0.5 rounded text-xs bg-gray-50 text-gray-400 hover:bg-gray-100 transition-colors"
        title="Click to assign teams"
      >
        No teams
      </button>
    );
  }

  const visibleTeams = teams.slice(0, MAX_VISIBLE_BADGES);
  const remainingCount = teams.length - MAX_VISIBLE_BADGES;

  return (
    <div className="flex items-center gap-1 flex-wrap">
      {visibleTeams.map((team) => {
        const RoleIcon = getRoleIcon(team.role);
        return (
          <button
            key={team.teamId}
            onClick={onClick}
            className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium ${getRoleBadgeColor(team.role)} hover:opacity-80 transition-opacity`}
            title={`${team.teamName} (${team.role})`}
          >
            <RoleIcon className="w-3 h-3" />
            <span className="max-w-[80px] truncate">{team.teamName}</span>
          </button>
        );
      })}
      {remainingCount > 0 && (
        <button
          onClick={onClick}
          className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors"
          title={`${remainingCount} more team${remainingCount > 1 ? 's' : ''}`}
        >
          +{remainingCount} more
        </button>
      )}
    </div>
  );
};

export default UserTeamBadges;
